var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("roles-menu"),
      _c(
        "v-row",
        { staticClass: "mb-3" },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    block: "",
                    color: "accent",
                    to: "/settings/role/new"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("settings.role.addNewRole")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.roleList,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.description))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(props.item.count_permissions) +
                        " / " +
                        _vm._s(props.item.count_parent_roles) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(props.item.count_users) +
                        " (" +
                        _vm._s(props.item.count_temp_users) +
                        ")"
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center text-no-wrap" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            to:
                                              "/settings/role/edit-users/" +
                                              encodeURIComponent(
                                                props.item.name
                                              ),
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("people")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("settings.role.assignUsers")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            to:
                                              "/settings/role/edit/" +
                                              encodeURIComponent(
                                                props.item.name
                                              ),
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              !_vm.canBeDeleted(props.item) ||
                                              _vm.$store.getters[
                                                "Ajax/loading"
                                              ],
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.remove(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          !_vm.canBeDeleted(props.item)
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("settings.role.detachUsersFirst")
                                  )
                                )
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("global.delete")))
                              ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }